var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.$style.direction, _vm.$style[_vm.direction]]},[_vm._t("left"),_vm._v(" "),_vm._t("right")],2)}
var staticRenderFns = []

export { render, staticRenderFns }